import AndroidIcon from 'flow/components/icons/AndroidIcon';
import AppleIcon from 'flow/components/icons/AppleIcon';
import IphoneIcon from 'flow/components/icons/IphoneIcon';
import WindowsIcon from 'flow/components/icons/WindowsIcon';
import AppImage from 'images/asset_devices.png';
import { getAppDownloadUrls, isTeamsAnyVersion } from 'flow/utils/app-utils';
import useAppContext from 'flow/hooks/useAppContext';

const AppInfo = () => {
    const { i18next, embedded } = useAppContext();

    const isTeams = isTeamsAnyVersion(embedded);
    const links = getAppDownloadUrls();

    if (isTeams || links === null) return null;

    return (
        <div
            id="app-info"
            className="flex h-72 items-center justify-around bg-gray-100"
        >
            <div
                id="image-box"
                className="flex h-40 w-64 shrink-0 flex-col justify-center bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${AppImage})` }}
            />
            <div
                id="text-box"
                className="flex h-40 w-64 shrink-0 flex-col justify-center"
            >
                <div className="text-2xl font-light text-gray-700">
                    {i18next.t('settings.general.info.title')}
                </div>
                <div className="my-4 flex">
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={links.android}
                        className="mr-4"
                    >
                        <AndroidIcon />
                    </a>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={links.ios}
                        className="mr-4"
                    >
                        <IphoneIcon />
                    </a>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={links.windows}
                        className="mr-4"
                    >
                        <WindowsIcon />
                    </a>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={links.mac}
                        className="mr-4"
                    >
                        <AppleIcon />
                    </a>
                </div>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={links.website}
                    className="text-link text-sm"
                >
                    {i18next.t('info.read.more')}
                </a>
            </div>
        </div>
    );
};

export default AppInfo;
